<!--
    Summary:
        测试特点
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
    <div class="v-p6-advantages" title="p6-advantages">
      <div class="header">
        <h2>{{$t('YDnaTest.advantages_title')}}</h2>
      </div>
      <div class="content">
        <div class="box">
          <img src="../../../assets/images/projects/y1.png"/>
          <div class="info">
            <h5>{{$t('YDnaTest.advantages_1_1')}}</h5>
            <p>{{$t('YDnaTest.advantages_1_2')}}</p>
          </div>
        </div>
        <div class="box">
          <img src="../../../assets/images/projects/y2.png"/>
          <div class="info">
            <h5>{{$t('YDnaTest.advantages_2_1')}}</h5>
            <p>{{$t('YDnaTest.advantages_2_2')}}</p>
          </div>
        </div>
        <div class="box">
          <img src="../../../assets/images/projects/y3.png"/>
          <div class="info">
            <h5>{{$t('YDnaTest.advantages_3_1')}}</h5>
            <p>{{$t('YDnaTest.advantages_3_2')}}</p>
          </div>
        </div>
        <div class="box">
          <img src="../../../assets/images/projects/y4.png"/>
          <div class="info">
            <h5>{{$t('YDnaTest.advantages_4_1')}}</h5>
            <p>{{$t('YDnaTest.advantages_4_2')}}</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "p6-advantages"
    }
</script>

<style scoped lang="scss">
    .v-p6-advantages {
      text-align: center;
      padding: 3vw 15vw;
      background: url("../../../assets/images/projects/y-bg.jpg");
      background-size: 100% 100%;
      .header{
        margin-bottom: 2.5vw;
        h2{
          color: #273a63;
          font-size: 2.66vw;
          font-weight: bold;
        }
      }
      .content{
        display: flex;
        justify-content: space-between;
        .box{
          width: 25%;
          img{
            width: 10.94vw;
            height: 10.26vw;
            margin-bottom: 2.76vw;
          }
          .info{
            h5{
              font-size: 1.77vw;
              font-weight: bold;
              margin-bottom: .78vw;
            }
            p{
              font-size: 1.2vw;
              font-weight: lighter;
            }
          }
        }
      }

    }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p6-advantages.vue